import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Search, Copy, Check, ChevronDown, ChevronUp } from 'lucide-react';
import Navbar from './Navbar';
   import { Link } from 'react-router-dom';
import Footer from './Footer';
// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

export default function EnhancedR1Page() {
  // FAQ State Management
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [expandedQuestions, setExpandedQuestions] = useState({});
  const [copiedId, setCopiedId] = useState(null);

  // FAQ Data - All questions from your PDFs
  const faqData = [
    {
      category: "Enhanced R1 Framework",
      questions: [
        {
          id: 1,
          question: "Is there a common database on one stop-portal to check the workers training status?",
          answer: "The Government is working with the ASPRI on ways to streamline the tracking process for the industry. More information will be shared with the industry when ready."
        },
        {
          id: 2,
          question: "Is this framework only applicable for WPH in the Process sector?",
          answer: "Yes, the Enhanced R1 framework is only applicable for Process Work Permit Holders (WPHs)."
        },
        {
          id: 3,
          question: "R1 for existing workers have up to 30 Jun 2025 to upgrade to Enhanced R1 Framework? Does the current R1 validity be revoked immediately on 01 Jan 2026 if I do not complete the courses before that?",
          answer: "The Enhanced R1 Framework will be implemented no earlier than 1 January 2026. Upon implementation of the Enhanced R1 Framework, existing R1 WPHs will be assessed based on the new criteria and accorded the status that they qualify for (i.e., if the R1 WPH did not meet the new criteria by the implementation date, he will be dropped to R2). To encourage companies to adopt the Enhanced R1 Framework, WPHs that complete the Enhanced R1 courses early will enjoy longer course validity beyond the default 24 months."
        },
        {
          id: 4,
          question: "The skills certification will be tagged to the company or the workers?",
          answer: "Similar to existing practice, skills certification will be tagged to the individual WPH. If a WPH changes his company of employment, the skills certification will remain valid. Eligibility for R1 status will depend on whether the WPH fulfils the skills qualifications requirements, as well as the secondary criteria (i.e., drawing a Fixed Monthly Salary of ≥ $1,200, Period of employment ≥ 4 years, company of employment to obtain a PCF rating of at least Bronze)."
        },
        {
          id: 5,
          question: "To clarify for our current R1 workers, in order to attain enhanced R1 to stay in R1 status, what are the requirements?",
          answer: "WPHs that have attained R1 status prior to Enhanced R1 implementation date are expected to meet the following criteria in order retain their R1 status: Skills Qualifications (2 x Level 1 Proficiency Test & Refresher, 1 x Level 2 Deep-skilling course, 1 x Safety course) and Satisfy one of the secondary criteria (Fixed Monthly Salary ≥ $1,200, Period of Employment ≥ 4 years, or Productivity Certification Framework (PCF) rating of at least Bronze)."
        },
        {
          id: 28,
          question: "If the Period of Employment (POE) is at minimum of 3 and 4 years, can MOM review the work permit valid period from 2 years to 4 years or more?",
          answer: "These adjustments to R1 framework are intended to sustain the sector to achieve higher productivity with a skilled workforce. Workers can attend the enhanced R1 courses prior to having 4 years of Period of Employment (POE). Work permits, including those issued at first instance and at renewals generally have a 2-year validity unless the employers choose not to or worker has insufficient validity on his/her passport or security bond. Upon expiry of the work permit, companies can continue to renew the worker's work permit, subject to their respective workforce needs and MOM workforce requirements. There are 3 pathways under which a worker can obtain R1 status."
        }
      ]
    },
    {
      category: "Incentives for Early Adoption",
      questions: [
        {
          id: 6,
          question: "How does employers/contractors benefit from this R1 enhanced framework?",
          answer: "Companies which have trained and upskilled their workers under the Enhanced R1 framework, would continue to enjoy a lower Foreign Worker levy rate for 'higher skilled workers' (or 'R1 workers'). This translates into direct financial benefits for employers, through levy cost savings. To encourage companies to adopt the Enhanced R1 Framework, WPHs that complete the Enhanced R1 courses early will enjoy longer course validity beyond the default 24 months."
        },
        {
          id: 7,
          question: "From Apr 2024 to Dec 2025 is about 18 months. The longer validity period doesn't really give contractor benefit to embark on this earlier. Can we clarify on this?",
          answer: "Yes, WPHs that completes the Enhanced R1 courses early will enjoy longer course validity. The extended validity granted will only commence from the Enhanced R1 implementation date."
        },
        {
          id: 8,
          question: "Could this framework include multi-skilling and bundle-up with incentive to promote productivity?",
          answer: "The Enhanced R1 framework is designed to encourage both deep-skilling and multi-skilling among Process WPHs. For example, existing R2 and new WPHs are required to complete two different WSQ crafts (e.g., WSQ Perform Metal Scaffolding Work + WSQ Rotating Equipment Fitting Work) and attend Level-2 Deep-skilling on either one of the WSQ craft. This would provide WPHs with a strong foundation for multi-skilling."
        },
        {
          id: 9,
          question: "Why the workers need to attend 3 or 4 skill courses? Can it be combined into one course?",
          answer: "The Enhanced R1 framework offers WPHs a progressive approach to enhancing their skills set. The WSQ courses focus on establishing foundational knowledge to build skills competency whereas the Level 2 Deep-Skilling courses aim to provide WPHs with a deeper specialisation into a particular skillset, or to be multi-skilled. Lastly, the safety courses were added to elevate the safety awareness, risk assessment, and risk mitigation capability of the workforce."
        }
      ]
    },
    {
      category: "Skills Qualification/Certification",
      questions: [
        {
          id: 10,
          question: "The current WSQ courses vs the new COC level 1, Is there any difference if they already completed the WSQ courses?",
          answer: "Query has been addressed in the FAQ on 'Courses for Enhanced R1 Framework for Process Sector (updated)'. Please reference the FAQ which was circulated to the industry on 2nd Feb 2024, FAQ Q3 on 'Skills Qualification / Certification' for more information."
        },
        {
          id: 11,
          question: "The course can only be taken at specific Training Centres (TC) or only particular TC for qualifying to maintain the R1 status?",
          answer: "Query has been addressed in the FAQ on 'Courses for Enhanced R1 Framework for Process Sector (updated)'. Please reference the FAQ which was circulated to the industry on 2nd Feb 2024, FAQ Q2 on 'Skills Qualification / Certification' for more information."
        },
        {
          id: 12,
          question: "As a Non-Destructive Testing provider to the process industry, how can we upskill our staff as none of the WSQ courses are directly relevant to their work?",
          answer: "The current set of courses was developed based on the existing 13 WSQ skill sets that are recognised as part of the R1 framework for the Process sector. The skills sets were identified based on the industry workforce demographics and required skill sets to execute works in the process sector. In addition, there is a lack of training centres and expertise to provide NDT courses within the Process sector. Hence, workers are encouraged to enrol for courses most relevant to their existing skillset or vocation, based on the list of recognised courses."
        },
        {
          id: 13,
          question: "If the workers have level 2 capacity, can they skip level 1, e.g. of welding, if can they straight to take 6G test, rather than taking 2 tests?",
          answer: "The content for the WSQ course and Level 2 Deep skilling course for each craft are not repetitive. The Level 2 Deep-Skilling courses are an extension of the existing 13 sets of WSQ courses, which aim to provide WPHs with a deeper specialisation into a particular skillset, or to be multi-skilled. Additionally, the Level 1 PT&R are designed to refresh, enhance and test the skillset and knowledge of workers within their respective domains. Hence, it is necessary for WPHs to undergo PT&R for the WSQ and Level 2 Deep-Skilling course every 2 years to ensure that workers' skills remain relevant."
        },
        {
          id: 14,
          question: "Under R1, are courses totally skills-based or are workers expected to pass written exam too? Can the training providers look into having the courses in different languages?",
          answer: "The Workers' Capability workgroup under the Productivity Council (PC) recognises on the potential linguistic hurdle, therefore the workgroup has worked with the various Craft Technical Committees to design curriculum that can suit the majority of the Process workforce. The current set of courses developed by the Workers' Capability workgroup and ITE are predominantly based on testing the practical skill sets of the workers and the test questions are mostly pictorial and image-based questions that require limited language translations."
        },
        {
          id: 15,
          question: "Worker leaving company ranges from 1-3 years. Can we exclude current R1 skilled workers who joined by xxx year that they be allowed to move to Level 2 straight away?",
          answer: "Existing R1 WPHs does not require to complete 2 WSQ courses to retain R1 status upon the implementation of the Enhanced R1 framework. Instead, they are only required to complete the following courses to meet the skills qualification criteria under the new framework: 2 x Level 1 Proficiency Test & Refresher, 1 x Level 2 Deep-skilling course, 1 x Safety course."
        },
        {
          id: 18,
          question: "Are Level 1 new course and refresher level 1 course have the same course fee?",
          answer: "The course fee for WSQ courses and Level 1 Proficiency Test & Refresher are different. Companies may (i) refer to ASPRI-IPI website for the course fee for the WSQ courses; and (ii) reach out to the respective Workplace Training Centre for information on the course fee for the Level 1 Proficiency Test & Refresher and Level-2 Deep-skilling courses."
        },
        {
          id: 19,
          question: "How much the Course Fees, whether employer need to pay fees, or worker Need to Pay the Course Fees?",
          answer: "Companies may (i) refer to ASPRI-IPI website for the course fee for the WSQ courses; and (ii) reach out to the respective Workplace Training Centre for information on the course fee for the Level 1 Proficiency Test & Refresher and Level-2 Deep-skilling courses. There will not be funding provided to companies in the adoption of Enhanced R1 Framework."
        },
        {
          id: 20,
          question: "To clarify, the WSQ courses a pre-requisite to enhanced R1 pathway?",
          answer: "Yes. Under the Enhanced R1 framework, WPHs will need to complete 2 out of the 13 WSQ courses specific to the Process sector, one Level 2 Deep-skilling course and one Safety course to obtain higher-skilled (i.e., R1) status."
        },
        {
          id: 22,
          question: "Can the certification be tied to company AND workers. Concern of workers jumping companies once they complete the training paid by their current companies.",
          answer: "Similar to existing practice, skills certification will be tagged to the individual WPH."
        }
      ]
    },
    {
      category: "Productivity Certification Framework",
      questions: [
        {
          id: 24,
          question: "How often and who is reviewing the PCF framework?",
          answer: "The Certification Workgroup under the Productivity Council periodically reviews and refines the PCF framework, ensuring the productivity matrix remains aligned with the dynamic shifts in industry trends."
        },
        {
          id: 25,
          question: "When will we know more about the Productivity Certification Framework? How can one achieve Bronze Rating?",
          answer: "Introduced in 2019, the Productivity Certification Framework (PCF) is a holistic framework that adopts a systematic approach to drive productivity improvement. With enhanced productivity standards, businesses can achieve sustainable outcomes with a significant reduction in resources required, thereby improving the bottom line of businesses. Certified companies under the PCF have seen about 10% improvement in productivity. Companies can reach out to the Singapore Chemical Industry Council Limited (SCIC) at pcsect@scic.sg to better understand the PCF certification process."
        },
        {
          id: 26,
          question: "Are all the plant owners in Process industry supporting the PCF?",
          answer: "The Productivity Council comprising major E&C plant owners and PCM contractor companies are supportive of the Productivity Certification Framework. The Productivity Council continues to engage various plant owners in various platforms to create awareness and the benefits of the PCF."
        },
        {
          id: 27,
          question: "Is there any funding scheme available to adopt PCF and training effort by the employer?",
          answer: "Companies that choose to adopt the PCF can experience sustainable improvements in productivity, leading to enhanced profitability and competitiveness. Certified companies participating in the PCF have reported an average productivity increase of approximately 10%. Companies on this pathway will also have the flexibility of employing higher-skilled (i.e., R1) workers without having to meet the Fixed Monthly Salay or Period of Employment criteria. With these benefits to companies, there is no funding scheme available for companies to adopt Productivity Certification Framework (PCF)."
        }
      ]
    },
    {
      category: "Others",
      questions: [
        {
          id: 29,
          question: "What happened to those Technician that we demoted them to Work Permit Holder from S-Pass holders, are they still required to take up the R1 course?",
          answer: "S Pass holders who are converted to Work Permit holders can qualify for higher-skilled (i.e., R1) status if they meet the requirements for any of the prevailing R1 pathways. The worker will have to complete the required courses for R1 pathways which contains a skills component."
        },
        {
          id: 30,
          question: "If worker A is R1 under Process sector, and later is transferred to say Marine sector, will he be immediately reverted to Basic-Skilled at high levies once the transfer happens?",
          answer: "If the Work Permit holder is transferred to a different sector, this worker will have to meet the prevailing R1 pathways criteria of the sector to be eligible for lower levy. Work Permit holders could attend courses from other sectors provided they meet the application requirements set by the training provider. The period of employment refers to the total number of years spent working in Singapore."
        }
      ]
    }
  ];

  const categories = ['All', ...new Set(faqData.map(cat => cat.category))];

  const toggleQuestion = (id) => {
    setExpandedQuestions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    });
  };

  const filteredFAQs = faqData
    .filter(cat => selectedCategory === 'All' || cat.category === selectedCategory)
    .map(cat => ({
      ...cat,
      questions: cat.questions.filter(q =>
        q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        q.answer.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }))
    .filter(cat => cat.questions.length > 0);

  // Function to handle PDF download
  const handleDownloadPDF = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/documents/Enhanced-R1-Framework-Guide.pdf`;
    link.download = 'Enhanced-R1-Framework-Guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleViewPDF = () => {
    window.open(`${process.env.PUBLIC_URL}/documents/Enhanced-R1-Framework-Guide.pdf`, '_blank');
  };

  return (
    <div className="bg-white text-gray-900 font-sans overflow-x-hidden">
      <Navbar/>
      {/* Hero Banner Section with PDF Download */}
      <section className="relative h-96 bg-gradient-to-r from-green-600 to-green-800 flex items-center justify-center text-white overflow-hidden mt-32">
        <div 
          className="absolute inset-0  bg-center bg-fixed"
          style={{
            backgroundImage: "url('https://i0.wp.com/aspri.com.sg/wp-content/uploads/2024/02/table04-e1709172297567.png?fit=934%2C353&ssl=1')",
          }}
        >
          <div className="absolute inset-0 bg-green-900/70"></div>
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 text-center px-6 max-w-4xl"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
            Enhanced R1 Framework
          </h1>
          <p className="text-lg md:text-2xl text-green-100 mb-6 drop-shadow">
            Updates for the Process Sector
          </p>
          <p className="text-lg text-green-50 max-w-2xl mx-auto mb-8">
            Comprehensive guide to the new R1 framework effective from 1 January 2026
          </p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <button 
              onClick={handleDownloadPDF}
              className="bg-white text-green-600 px-6 py-3 rounded-full font-bold hover:bg-green-50 transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download PDF Guide
            </button>
            <button 
              onClick={handleViewPDF}
              className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-full font-bold hover:bg-white/10 transition-all flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              View Online
            </button>
          </motion.div>
        </motion.div>
      </section>

      {/* Implementation Timeline */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200"
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Implementation Timeline</h2>
            <p className="text-xl text-gray-700 mb-4">
              The Enhanced R1 framework will be implemented 
              <span className="font-bold text-green-600"> no earlier than 1 January 2026</span>
            </p>
            <p className="text-lg text-gray-600">
              This transition period allows companies to prepare their workforce for the new requirements
            </p>
          </motion.div>
        </div>
      </section>

      {/* Current vs Enhanced R1 Framework */}
     {/* Current vs Enhanced R1 Framework Comparison */}
<section className="py-20 px-6 bg-white relative overflow-hidden">
  {/* Subtle background animation */}
  <div className="absolute inset-0 overflow-hidden">
    <div className="absolute -top-40 -right-40 w-80 h-80 bg-green-100 rounded-full opacity-20 animate-pulse"></div>
    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-100 rounded-full opacity-20 animate-pulse delay-1000"></div>
  </div>
  
  <div className="max-w-7xl mx-auto relative z-10">
    {/* Section Header */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      className="text-center mb-16"
    >
      <div className="inline-flex items-center gap-3 bg-gray-100 px-6 py-3 rounded-full border border-gray-200 mb-6">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span className="text-gray-700 font-semibold text-sm uppercase tracking-wide">Framework Comparison</span>
      </div>
      <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
        Current vs Enhanced R1 Framework
      </h2>
      <p className="text-lg text-gray-600 max-w-3xl mx-auto">
        Key differences between current framework and upcoming Enhanced R1 requirements
      </p>
    </motion.div>

    {/* Comparison Cards */}
    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
      {/* Current Framework Card */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="group"
      >
        <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden h-full transform group-hover:-translate-y-1">
          {/* Card Header */}
          <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Current Framework</h3>
                <p className="text-orange-100 text-sm mt-1">Active until 31 Dec 2025</p>
              </div>
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6">
            <div className="space-y-4">
              {/* Pathway 1 */}
              <div className="bg-orange-50 rounded-xl p-4 border-l-4 border-orange-400 hover:bg-orange-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">1</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-orange-800 mb-2">Skills + Salary</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>2 x WSQ courses OR Composite Assessment</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>Fixed Monthly Salary ≥ $1,200</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Pathway 2 */}
              <div className="bg-orange-50 rounded-xl p-4 border-l-4 border-orange-400 hover:bg-orange-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">2</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-orange-800 mb-2">Skills + Experience</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>2 x WSQ courses OR Composite Assessment</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>Period of Employment ≥ 3 years</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Pathway 3 */}
              <div className="bg-orange-50 rounded-xl p-4 border-l-4 border-orange-400 hover:bg-orange-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">3</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-orange-800 mb-2">Market-Based</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>Period of Employment ≥ 3 years</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                        <span>Fixed Monthly Salary ≥ $1,200</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Enhanced Framework Card */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="group"
      >
        <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden h-full transform group-hover:-translate-y-1 relative">
          {/* New Badge */}
          <div className="absolute top-4 right-4 z-20">
            <div className="bg-green-500 text-white px-3 py-1 rounded-full font-bold text-xs shadow-lg animate-bounce">
              NEW
            </div>
          </div>

          {/* Card Header */}
          <div className="bg-gradient-to-r from-green-600 to-emerald-600 p-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Enhanced Framework</h3>
                <p className="text-green-100 text-sm mt-1">Effective from 1 Jan 2026</p>
              </div>
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6">
            <div className="space-y-4">
              {/* Pathway 1 */}
              <div className="bg-green-50 rounded-xl p-4 border-l-4 border-green-400 hover:bg-green-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">1</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-800 mb-2">Skills + Salary</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>2 x Level 1 WSQ courses</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Level 2 Deep-skilling course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Safety course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>FMS ≥ $1,200</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Pathway 2 */}
              <div className="bg-green-50 rounded-xl p-4 border-l-4 border-green-400 hover:bg-green-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">2</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-800 mb-2">Skills + Experience</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>2 x Level 1 WSQ courses</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Level 2 Deep-skilling course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Safety course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>POE ≥ 4 years</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Pathway 3 */}
              <div className="bg-green-50 rounded-xl p-4 border-l-4 border-green-400 hover:bg-green-100 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-xs">3</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-800 mb-2">Skills + PCF</h4>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>2 x Level 1 WSQ courses</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Level 2 Deep-skilling course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>1 x Safety course</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full"></div>
                        <span>PCF Rating of at least Bronze</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Requirements */}
            <div className="mt-6">
              <div className="bg-yellow-50 rounded-xl p-4 border-l-4 border-yellow-400">
                <h4 className="font-bold text-yellow-800 text-sm mb-2 flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                  Additional Requirements
                </h4>
                <ul className="space-y-1 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full"></div>
                    <span>PT&R every 2 years for L1 & L2 courses</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full"></div>
                    <span>Safety course is once-off (no refresher)</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>

    {/* Key Changes Summary */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="mt-16 bg-gray-50 rounded-2xl p-8 border border-gray-200"
    >
      <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">Key Changes Summary</h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { 
            title: "Enhanced Training", 
            desc: "4 courses required vs 2 previously",
            change: "+2 courses"
          },
          { 
            title: "Longer Experience", 
            desc: "POE increased from 3 to 4 years",
            change: "+1 year"
          },
          { 
            title: "Regular Testing", 
            desc: "PT&R every 2 years mandatory",
            change: "New requirement"
          },
          { 
            title: "New PCF Pathway", 
            desc: "Bronze rating or higher required",
            change: "New pathway"
          }
        ].map((item, index) => (
          <motion.div 
            key={index} 
            className="text-center p-4 bg-white rounded-xl border border-gray-200 hover:shadow-md transition-shadow"
            whileHover={{ scale: 1.02 }}
          >
            <div className="text-lg font-bold text-gray-600 mb-2">{item.change}</div>
            <h4 className="font-bold text-gray-800 mb-2">{item.title}</h4>
            <p className="text-sm text-gray-600">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  </div>
</section>

      {/* Key Changes Summary */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-800 text-center mb-12"
          >
            Key Changes in Enhanced R1 Framework
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Enhanced Training Requirements",
                items: [
                  "Skills qualifications raised from 2 to 4 courses",
                  "Introduction of Level 2 Deep-skilling course",
                  "Mandatory safety course requirement",
                  "Composite Assessment remains as alternative for one L1 WSQ"
                ]
              },
              {
                title: "Increased Experience Requirement",
                items: [
                  "Period of Employment increased from 3 to 4 years",
                  "Better recognition of experienced workers",
                  "Enhanced workforce stability requirements"
                ]
              },
              {
                title: "Regular Proficiency Testing",
                items: [
                  "PT&R required every 2 years for L1 and L2 courses",
                  "Mandatory for R1 status retention",
                  "Ensures skills remain current and relevant"
                ]
              },
              {
                title: "New PCF Pathway",
                items: [
                  "Productivity Certification Framework introduced",
                  "Bronze rating or higher required",
                  "Alternative qualification pathway for companies"
                ]
              },
              {
                title: "Safety Course Integration",
                items: [
                  "Once-off safety course completion",
                  "No refresher required for safety course",
                  "Enhanced workplace safety focus"
                ]
              },
              {
                title: "Early Adoption Incentives",
                items: [
                  "Longer course validity for early completions",
                  "Progressive reduction in validity period",
                  "Encourages timely workforce upgrading"
                ]
              }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-200"
              >
                <h3 className="text-xl font-bold text-green-700 mb-4">{feature.title}</h3>
                <ul className="space-y-2">
                  {feature.items.map((item, i) => (
                    <li key={i} className="flex items-start text-gray-700">
                      <span className="text-green-600 mr-2 mt-1">•</span>
                      <span className="text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Worker Transition Requirements */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-800 text-center mb-12"
          >
            Worker Transition Requirements
          </motion.h2>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Existing R1 Workers */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-blue-500"
            >
              <h3 className="text-2xl font-bold text-blue-600 mb-6 text-center">Existing R1 Workers</h3>
              
              <div className="space-y-4">
                <div className="text-center mb-6">
                  <div className="bg-blue-100 text-blue-800 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-3">
                    R1
                  </div>
                  <p className="text-sm text-gray-600">Currently holding R1 status</p>
                </div>

                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">1</span>
                    <span className="text-sm">Complete 2x PT&R for existing skillsets</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">2</span>
                    <span className="text-sm">Complete Level 2 Deep-skilling course</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">3</span>
                    <span className="text-sm">Complete Safety course (once-off)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">4</span>
                    <span className="text-sm">Meet one secondary criteria</span>
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* Existing R2 Workers */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-orange-500"
            >
              <h3 className="text-2xl font-bold text-orange-600 mb-6 text-center">Existing R2 Workers</h3>
              
              <div className="space-y-4">
                <div className="text-center mb-6">
                  <div className="bg-orange-100 text-orange-800 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-3">
                    R2
                  </div>
                  <p className="text-sm text-gray-600">Currently holding R2 status</p>
                </div>

                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="bg-orange-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">1</span>
                    <span className="text-sm">Complete 2x Level 1 WSQ courses</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-orange-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">2</span>
                    <span className="text-sm">Complete Level 2 Deep-skilling course</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-orange-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">3</span>
                    <span className="text-sm">Complete Safety course</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-orange-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">4</span>
                    <span className="text-sm">Meet one secondary criteria</span>
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* New Workers */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-green-500"
            >
              <h3 className="text-2xl font-bold text-green-600 mb-6 text-center">New Workers</h3>
              
              <div className="space-y-4">
                <div className="text-center mb-6">
                  <div className="bg-green-100 text-green-800 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-3">
                    New
                  </div>
                  <p className="text-sm text-gray-600">New to Singapore workforce</p>
                </div>

                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="bg-green-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">1</span>
                    <span className="text-sm">Complete all 4 Enhanced R1 courses</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-green-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">2</span>
                    <span className="text-sm">Accumulate 4 years POE in Singapore</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-green-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">3</span>
                    <span className="text-sm">Meet FMS ($1,200) requirement</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-green-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-1 flex-shrink-0">4</span>
                    <span className="text-sm">Maintain R1 status with 2-year PT&R</span>
                  </li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Course Validity Periods */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-800 text-center mb-12"
          >
            Early Adoption Course Validity Periods
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 shadow-lg border border-gray-200"
          >
            <p className="text-lg text-gray-700 text-center mb-8">
              Complete Enhanced R1 courses early to enjoy extended validity periods
            </p>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { period: "1 April - 30 June 2024", validity: "32 months", color: "bg-green-500" },
                { period: "1 July - 30 September 2024", validity: "31 months", color: "bg-green-400" },
                { period: "1 October - 31 December 2024", validity: "30 months", color: "bg-blue-400" },
                { period: "1 January - 31 March 2025", validity: "26 months", color: "bg-blue-500" },
                { period: "1 April - 30 June 2025", validity: "25 months", color: "bg-purple-400" },
                { period: "From 1 July 2025 onwards", validity: "24 months", color: "bg-purple-500" },
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition-shadow">
                  <div className={`${item.color} text-white rounded-full w-14 h-14 flex items-center justify-center text-lg font-bold mx-auto mb-3`}>
                    {item.validity.split(' ')[0]}
                  </div>
                  <div className="font-semibold text-gray-800 mb-2 text-sm">{item.period}</div>
                  <div className="text-2xl font-bold text-gray-900">{item.validity}</div>
                  <div className="text-sm text-gray-600 mt-1">validity period</div>
                </div>
              ))}
            </div>

            <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
              <p className="text-sm text-yellow-800 text-center">
                <strong>Note:</strong> Course validity periods are calculated from the Enhanced R1 implementation date (1 January 2026)
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ========== FAQ SECTION STARTS HERE ========== */}
      <section className="py-16 px-6 bg-gray-50" id="faq-section">
        <div className="max-w-6xl mx-auto">
          {/* FAQ Header */}
          <div className="text-center mb-12">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-4xl font-bold text-gray-800 mb-4"
            >
              Frequently Asked Questions
            </motion.h2>
            <p className="text-lg text-gray-600">
              Find answers to common questions about the Enhanced R1 Framework
            </p>
          </div>

          {/* Search Bar */}
          <div className="mb-8">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search questions or answers..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-4 rounded-xl border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none text-gray-900 bg-white shadow-sm"
              />
            </div>
          </div>

          {/* Category Filter */}
          <div className="mb-8 flex flex-wrap gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-5 py-2.5 rounded-full font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-green-600 text-white shadow-md'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* FAQ List */}
          <div className="space-y-8">
            {filteredFAQs.map((category) => (
              <div key={category.category} className="bg-white rounded-2xl shadow-md p-6 border border-gray-200">
                <h3 className="text-2xl font-bold text-green-700 mb-6 pb-3 border-b-2 border-green-100">
                  {category.category}
                </h3>
                
                <div className="space-y-4">
                  {category.questions.map((item) => (
                    <div
                      key={item.id}
                      className="border border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                    >
                      <button
                        onClick={() => toggleQuestion(item.id)}
                        className="w-full flex items-start justify-between p-5 text-left hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex-1 pr-4">
                          <h4 className="font-semibold text-gray-900 leading-relaxed">
                            {item.question}
                          </h4>
                        </div>
                        <div className="flex-shrink-0">
                          {expandedQuestions[item.id] ? (
                            <ChevronUp className="w-5 h-5 text-green-600" />
                          ) : (
                            <ChevronDown className="w-5 h-5 text-gray-400" />
                          )}
                        </div>
                      </button>

                      {expandedQuestions[item.id] && (
                        <div className="px-5 pb-5 pt-2 bg-gray-50 border-t border-gray-200">
                          <div className="flex items-start justify-between gap-4">
                            <p className="text-gray-700 leading-relaxed flex-1">
                              {item.answer}
                            </p>
                            <button
                              onClick={() => copyToClipboard(item.answer, item.id)}
                              className="flex-shrink-0 p-2 hover:bg-gray-200 rounded-lg transition-colors"
                              title="Copy answer"
                            >
                              {copiedId === item.id ? (
                                <Check className="w-5 h-5 text-green-600" />
                              ) : (
                                <Copy className="w-5 h-5 text-gray-500" />
                              )}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {filteredFAQs.length === 0 && (
            <div className="text-center py-12 bg-white rounded-2xl shadow-md">
              <div className="text-gray-400 mb-4">
                <Search className="w-16 h-16 mx-auto" />
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No results found
              </h3>
              <p className="text-gray-500">
                Try adjusting your search terms or selected category
              </p>
            </div>
          )}
        </div>
      </section>

      {/* PDF Downloads Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-800 text-center mb-12"
          >
            Download Official Documents
          </motion.h2>
          
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {/* Main FAQ PDF */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-blue-500 p-3 rounded-lg flex-shrink-0">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Enhanced R1 Framework FAQ
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Comprehensive FAQ document with all framework details and requirements
                  </p>
                  <button
                    onClick={() => {
                      const link = document.createElement('a');
                      link.href = `${process.env.PUBLIC_URL}/documents/FAQ-on-Updates-on-Enhanced-R1-Framework-for-Process-Sector_2-Feb-2024.pdf`;
                      link.download = 'FAQ-on-Updates-on-Enhanced-R1-Framework-for-Process-Sector_2-Feb-2024.pdf';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    className="bg-blue-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-blue-700 transition-all flex items-center gap-2 text-sm shadow-md hover:shadow-lg"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Download PDF
                  </button>
                </div>
              </div>
            </div>

            {/* Additional FAQs PDF */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 border border-green-200 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-green-500 p-3 rounded-lg flex-shrink-0">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Additional FAQs on Updates
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Supplementary questions and detailed responses on framework implementation
                  </p>
                  <button
                    onClick={() => {
                      const link = document.createElement('a');
                      link.href = `${process.env.PUBLIC_URL}/documents/Additional-FAQs-on-Update-on-Enhanced-R1-framework-for-Process-Sector_VF1.pdf`;
                      link.download = 'Additional-FAQs-on-Update-on-Enhanced-R1-framework-for-Process-Sector_VF1.pdf';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    className="bg-green-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-green-700 transition-all flex items-center gap-2 text-sm shadow-md hover:shadow-lg"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Download PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Download Both Button */}
          <div className="text-center">
            <button
              onClick={() => {
                const link1 = document.createElement('a');
                link1.href = `${process.env.PUBLIC_URL}/documents/FAQ-on-Updates-on-Enhanced-R1-Framework-for-Process-Sector_2-Feb-2024.pdf`;
                link1.download = 'FAQ-on-Updates-on-Enhanced-R1-Framework-for-Process-Sector_2-Feb-2024.pdf';
                document.body.appendChild(link1);
                link1.click();
                document.body.removeChild(link1);

                setTimeout(() => {
                  const link2 = document.createElement('a');
                  link2.href = `${process.env.PUBLIC_URL}/documents/Additional-FAQs-on-Update-on-Enhanced-R1-framework-for-Process-Sector_VF1.pdf`;
                  link2.download = 'Additional-FAQs-on-Update-on-Enhanced-R1-framework-for-Process-Sector_VF1.pdf';
                  document.body.appendChild(link2);
                  link2.click();
                  document.body.removeChild(link2);
                }, 500);
              }}
              className="bg-gray-800 text-white px-8 py-3 rounded-full font-bold hover:bg-gray-900 transition-all shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download Both PDFs
            </button>
          </div>
        </div>
      </section>

      {/* Final Call to Action */}
      <section className="py-20 px-6 bg-gradient-to-r from-green-600 to-green-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h2 className="text-4xl font-bold mb-6">Begin Your Enhanced R1 Transition Today</h2>
            <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto leading-relaxed">
              Prepare your workforce for the upcoming Enhanced R1 Framework implementation. 
              Start early to maximize benefits and ensure seamless compliance with the new requirements.
            </p>
            
  

<div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
  <Link
    to="/courses"
    className="bg-white text-green-600 px-8 py-3 rounded-full font-bold hover:bg-green-50 transition-all shadow-lg hover:shadow-xl"
  >
    Explore Available Courses
  </Link>
  <Link
    to="/contact"
    className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-full font-bold hover:bg-white/10 transition-all inline-block"
  >
    Contact Us
  </Link>
</div>

          </motion.div>
        </div>
      </section>
        {/* <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 right-6 bg-[#0b9949] text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition z-50"
      >
        ↑
      </button> */}
      <Footer/>
    </div>
  );
}